export enum REWARD_TYPE {
    COIN,//金币
    POWER,//体力
    DIAMOND,//钻石
    CUSTOM,//自定义
}